import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkApi } from '../../store'
import { enqueueErrorSnackbar, enqueueSuccessSnackbar } from './notificationActions'
import { AdScheduledEvent, AdScheduledEventInit, AdScheduledEventParams } from 'common/types'

export const createAdScheduledEvent = createAsyncThunk<AdScheduledEvent[], AdScheduledEventInit, ThunkApi>(
  'adScheduledEvents/createAdScheduledEvent',
  async (eventInit, { dispatch, extra: { api } }) => {
    try {
      const res = await api.adScheduledEventsApi.createAdScheduledEvent(eventInit)

      const eventTypeMessages = {
        'ad-break': 'Scheduled ad break',
        blackout: 'Scheduled blackout',
        resumption: 'Scheduled resumption',
      }

      dispatch(enqueueSuccessSnackbar(eventTypeMessages[eventInit.eventType]))
      return res
    } catch (error) {
      dispatch(enqueueErrorSnackbar({ error, operation: 'create scheduled event' }))
      throw error
    }
  },
)

export const createManyAdScheduledEvents = createAsyncThunk<AdScheduledEvent[], AdScheduledEventInit[], ThunkApi>(
  'adScheduledEvents/createManyAdScheduledEvents',
  async (eventInits, { dispatch, extra: { api } }) => {
    try {
      const results: AdScheduledEvent[] = []

      for (const eventInit of eventInits) {
        const res = await api.adScheduledEventsApi.createAdScheduledEvent(eventInit)
        results.push(...res)
      }

      const eventTypeMessages = {
        'ad-break': 'ad breaks',
        blackout: 'blackouts',
        resumption: 'resumptions',
      }

      const eventType = eventInits[0]?.eventType
      const count = eventInits.length

      if (eventType && count > 0) {
        dispatch(enqueueSuccessSnackbar(`Scheduled ${count} ${eventTypeMessages[eventType]}`))
      }

      return results
    } catch (error) {
      dispatch(enqueueErrorSnackbar({ error, operation: 'create scheduled events' }))
      throw error
    }
  },
)

export const createAdScheduledEventForInputList = createAsyncThunk<
  AdScheduledEvent[],
  { inputListId: string; event: AdScheduledEventParams },
  ThunkApi
>(
  'adScheduledEvents/createAdScheduledEventForInputList',
  async ({ inputListId, event }, { dispatch, extra: { api } }) => {
    try {
      const result = await api.adScheduledEventsApi.createAdScheduledEventForInputList(inputListId, event)
      const eventTypeMessages = {
        'ad-break': 'ad break',
        blackout: 'blackout',
        resumption: 'resumption',
      }
      dispatch(enqueueSuccessSnackbar(`Scheduled ${eventTypeMessages[event.eventType]} for input list`))
      return result
    } catch (error) {
      dispatch(enqueueErrorSnackbar({ error, operation: 'create scheduled event for input list' }))
      throw error
    }
  },
)
